import { ref, onMounted, onBeforeUnmount } from 'vue';
import {
  DASHBOARD_THEME_CHANGE_EVENT,
  isDarkThemeEnabled,
} from 'dashboard/helper/themeHelper';

export const useDarkTheme = () => {
  const isDarkTheme = ref(isDarkThemeEnabled());

  const syncTheme = event => {
    if (typeof event?.detail?.isDark === 'boolean') {
      isDarkTheme.value = event.detail.isDark;
      return;
    }

    isDarkTheme.value = isDarkThemeEnabled();
  };

  onMounted(() => {
    syncTheme();
    window.addEventListener(DASHBOARD_THEME_CHANGE_EVENT, syncTheme);
  });

  onBeforeUnmount(() => {
    window.removeEventListener(DASHBOARD_THEME_CHANGE_EVENT, syncTheme);
  });

  return {
    isDarkTheme,
  };
};
